import type { PropertyResponse } from '@/shared/api';
import { Card, CardBody, Eyebrow, ReadOnlyValue } from '@/shared/components';
import { formatCurrency, formatDate } from '@/shared/lib/format';

export function ArchivedPropertySnapshot({ property }: { property: PropertyResponse }) {
  const address = [property.address.street, property.address.postalCode, property.address.city]
    .filter(Boolean)
    .join(', ');

  return (
    <>
      <header className="mb-6">
        <Eyebrow>Archivübersicht</Eyebrow>
        <h2 className="text-ink mt-3 font-serif text-3xl font-normal tracking-tight">
          Bestand für <span className="font-serif-italic">Nachweise</span>
          <span className="text-sealwax">.</span>
        </h2>
      </header>
      <div className="grid gap-4 lg:grid-cols-2">
        <Card>
          <CardBody className="pt-6">
            <Eyebrow variant="muted" className="mb-4">
              Stammdaten
            </Eyebrow>
            <dl className="divide-line/60 divide-y">
              <ReadOnlyValue label="Adresse" value={address || '—'} />
              <ReadOnlyValue label="Typ" value={property.propertyType} />
              <ReadOnlyValue label="Zeitzone" value={property.timezone} />
              <ReadOnlyValue label="Slug" value={property.slug} mono />
            </dl>
          </CardBody>
        </Card>
        <Card>
          <CardBody className="pt-6">
            <Eyebrow variant="muted" className="mb-4">
              Historischer Rahmen
            </Eyebrow>
            <dl className="divide-line/60 divide-y">
              <ReadOnlyValue label="Angelegt" value={formatDate(property.createdAt)} />
              <ReadOnlyValue label="Letzte Änderung" value={formatDate(property.updatedAt)} />
              <ReadOnlyValue
                label="Basispreis"
                value={formatCurrency(property.baseNightlyRate, property.currency)}
              />
              <ReadOnlyValue
                label="Reinigung"
                value={formatCurrency(property.cleaningFee, property.currency)}
              />
            </dl>
          </CardBody>
        </Card>
      </div>
      {property.description && (
        <Card className="mt-4">
          <CardBody className="pt-6">
            <Eyebrow variant="muted" className="mb-3">
              Notizen · intern
            </Eyebrow>
            <p className="text-ink-soft whitespace-pre-wrap text-sm leading-relaxed">
              {property.description}
            </p>
          </CardBody>
        </Card>
      )}
    </>
  );
}
